import {Component, input, ChangeDetectionStrategy} from '@angular/core';
import {ActionType} from "../../models/action.type";
import {FlexModule} from "@ngbracket/ngx-layout";

@Component({
  selector: 'app-lib-callout',
  imports: [
    FlexModule
  ],
  templateUrl: './callout.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './callout.component.scss'
})
export class CalloutComponent {

  type = input.required<ActionType>();
  title = input<string>();
  content = input<string|null>(null);
}
